import React from 'react';
import Title from 'app/components/layout/Title';
import Loader from 'app/components/general/Loader';
import _ from 'lodash';
import { Link } from 'react-router-dom';

interface Descriptor {
  icon: any;
  descriptor: string;
}

interface Metadata {
  title: any;
  value: string;
}

interface IHeaderProps {
  title: string;
  titleUnit: string;
  subtitle: string;
  breadcrumb: string;
  breadcrumbLink: string;
  descriptors: Descriptor[];
  metadata: Metadata[];
  badge: React.ReactNode;
  isLoading: boolean;
}

export default class Header extends React.Component<IHeaderProps> {
  static defaultProps: IHeaderProps = {
    title: '',
    titleUnit: '',
    subtitle: '',
    breadcrumb: '',
    breadcrumbLink: '',
    descriptors: [],
    metadata: [],
    badge: undefined,
    isLoading: false,
  };

  renderBreadcrumb() {
    if (!_.isEmpty(this.props.breadcrumb)) {
      return (
        <Link
          to={this.props.breadcrumbLink}
          onClick={this.onClick}
          className="header-breadcrumb"
        >
          {this.props.breadcrumb}
        </Link>
      );
    }
    return null;
  }

  renderSubtitle() {
    if (!_.isEmpty(this.props.subtitle)) {
      return <h2 className="subtitle">{this.props.subtitle}</h2>;
    }
    return null;
  }

  renderDescriptors = (): React.ReactNode => _.map(
    this.props.descriptors,
    (descriptor): React.ReactNode => !_.isEmpty(descriptor.descriptor) && (
      <div className="header-descriptor" key={descriptor.descriptor}>
        <div className="header-descriptor-icon">{descriptor.icon}</div>
        <div className="header-descriptor-value">
          {descriptor.descriptor}
        </div>
      </div>
    ),
  );

  renderMetadata = (): React.ReactNode => _.map(
    this.props.metadata,
    (metadata): React.ReactNode => !_.isEmpty(metadata.value) && (
      <div className="header-metadata" key={metadata.title}>
        <div className="header-metadata-title">{metadata.title}</div>
        <div className="header-metadata-value">{metadata.value}</div>
      </div>
    ),
  );

  render(): React.ReactNode {
    return (
      <div className="header-container">
        <div className="row">
          <div className="col">
            {/* {this.renderBreadcrumb()} */}
            <Title
              title={this.props.title}
              unit={this.props.titleUnit}
              breadcrumb={!_.isEmpty(this.props.breadcrumb)}
              badge={this.props.badge}
              isLoading={this.props.isLoading}
            />
            {/* {this.renderSubtitle()} */}
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="header-descriptor-container">
              {this.props.isLoading && (
                <Loader
                  skeleton
                  height={25}
                  count={1}
                  width={200}
                  isActive
                  color="grey"
                />
              )}
              {!this.props.isLoading && this.renderDescriptors()}
            </div>
            <div className="divider full less-margin" />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="header-metadata-container">
              {this.props.isLoading && (
                <Loader
                  skeleton
                  height={25}
                  count={1}
                  width={400}
                  isActive
                  color="grey"
                />
              )}
              {!this.props.isLoading && this.renderMetadata()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
